import { render, staticRenderFns } from "./pageElementCroppedimage.vue?vue&type=template&id=27836020&scoped=true&"
import script from "./pageElementCroppedimage.vue?vue&type=script&lang=js&"
export * from "./pageElementCroppedimage.vue?vue&type=script&lang=js&"
import style0 from "./pageElementCroppedimage.vue?vue&type=style&index=0&id=27836020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27836020",
  null
  
)

export default component.exports